import React from 'react';
import { Link } from 'react-router-dom';

const developers = [
    { name: 'ATS', image: '/projects/3/1.jpeg' },
    { name: 'Saya', image: '/projects/9/1.jpeg' },
    { name: 'Supertech', image: '/projects/8/2.jpg' },
    { name: 'Gaur Sons', image: '/projects/12/1.jpg' },
    { name: 'Spectrum Mall', image: '/projects/10/1.jpeg' },
    { name: 'T&T', image: '/projects/6/2.jpeg' },
    { name: 'Paras Estate', image: '/projects/13/1.jpg' },
    { name: 'Navrang Square', image: '/projects/2/2.jpeg' },
    { name: 'Amba Deep', image: '/projects/4/1.jpeg' },
    { name: 'CSN', image: '/projects/1/1.jpeg' },
    { name: 'Central Market', image: '/projects/11/1.jpeg' },
];

const DeveloperStrip = () => {
    return (
        <section className="dev-strip" aria-labelledby="dev-strip-heading">
            <div className="container dev-strip-intro">
                <p className="eyebrow">Clients</p>
                <h2 id="dev-strip-heading" className="section-title">Prestigious Developers We Serve</h2>
            </div>
            <div className="dev-strip-wrap">
                <div className="dev-strip-track">
                    {[0, 1].map((copy) => (
                        <div className="dev-strip-set" key={copy} aria-hidden={copy === 1 || undefined}>
                            {developers.map((developer) => (
                                <Link
                                    className="dev-strip-item"
                                    to="/clients"
                                    tabIndex={copy === 1 ? -1 : undefined}
                                    key={`${copy}-${developer.name}`}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}${developer.image}`}
                                        alt=""
                                    />
                                    <span>{developer.name}</span>
                                </Link>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DeveloperStrip;
